import axios, { POST, GET } from './axios'
import { _getProductDetails } from 'app-api-user-service'

let cachedProductDetailsResponse = {};
// caching product details, using material id as key
export const getProductDetailsCachedData = async (data) => {
  const materialId = data?.materialId;
  if (cachedProductDetailsResponse[materialId]) {
    return cachedProductDetailsResponse[materialId];
  }

  return await getProductDetails(data);
}

/** Get Product Details API
 *
 * Get product details using the provided options
 * @param {string} locale - User locale
 * @param {string} materialId - Unique product id
 * @param {string} salesOrg
 * @param {boolean=} includeSpecifications
 */
export const getProductDetails = async ({
  locale,
  materialId,
  salesOrg,
  userInformation,
  isLoggedIn,
  isIPSUser = false,
  contractName,
  contractId,
  includeSpecifications = true,
  includeVariants = true,
  includeSubscriptionInfo = false,
}) => {
  const cache = cachedProductDetailsResponse[materialId];
  if (cache) {
    return cache;
  }
  const newProductDetails = await _getProductDetails({
    locale,
    materialId,
    salesOrg,
    userInformation,
    isLoggedIn,
    isIPSUser,
    contractName,
    contractId,
    includeSpecifications,
    includeVariants,
    includeSubscriptionInfo
  })
  cachedProductDetailsResponse[materialId] = newProductDetails;
  return newProductDetails;
}

/** Get Product Information API - Used for mini PDP
 *
 * Get product information using the provided options
 * @param {string} locale - User locale
 * @param {string} materialId - Unique product id
 */

export const getProductInformation = async ({ contractId, locale, materialId, salesOrg }) => {
  try {
    const res = await axios({
      method: GET,
      url: `/insightweb/cs/endUser/productInformation`,
      params: { locale, matId: materialId, contractId, salesOrg },
    })
    return res
  } catch (err) {
    console.warn(`Failed to fetch PDP information`, err)
    throw err
  }
}

export default {
  getProductDetails,
  getProductInformation,
}
